<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="活动标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入活动标题" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="主页背景图片" prop="bgImg">
        <uploadImg v-model="form.bgImg" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="抽奖动画" prop="drawBgImg">
        <uploadImg v-model="form.drawBgImg" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="开启页背景" prop="openBgImg">
        <uploadImg v-model="form.openBgImg" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="申请页背景" prop="supBgImg">
        <uploadImg v-model="form.supBgImg" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="邀请海报" prop="posterId">
        <el-select v-model="form.posterId" placeholder="选择邀请海报">
          <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支持海报" prop="supPosterId">
        <el-select v-model="form.supPosterId" placeholder="选择支持海报">
          <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          placeholder="选择开始时间"
          @change="getStartTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          placeholder="选择结束时间"
          @change="getEndTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="老用户支持分数类型">
        <el-radio-group v-model="form.oldUserValType">
          <el-radio :label="0">固定值</el-radio>
          <el-radio :label="1">随机值</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="老用户支持分数(固定值)" v-if="form.oldUserValType == 0">
        <el-input-number
          v-model="form.oldUserVal"
          size="medium"
          :min="0"
          :max="100"
          label="请输入老用户支持分数"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="老用户支持分数(随机值)" v-if="form.oldUserValType == 1">
        <el-input-number
          v-model="form.oldUserVal"
          size="medium"
          :min="0"
          :max="100"
          label="请输入开始分数"
        ></el-input-number>
        <el-input-number
          v-model="form.oldUserValEnd"
          size="medium"
          :min="0"
          :max="100"
          label="请输入结束分数"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="新用户支持分数类型" required>
        <el-radio-group v-model="form.newUserValType">
          <el-radio :label="0">固定值</el-radio>
          <el-radio :label="1">随机值</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="新用户支持分数(固定值)" v-if="form.newUserValType == 0" required>
        <el-input-number
          v-model="form.newUserVal"
          size="medium"
          :min="0"
          :max="100"
          label="请输入新用户支持分数"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="新用户支持分数(随机值)" v-if="form.newUserValType == 1" required>
        <el-input-number
          v-model="form.newUserVal"
          size="medium"
          :min="0"
          :max="100"
          label="请输入开始分数"
        ></el-input-number>
        <el-input-number
          v-model="form.oldUserValEnd"
          size="medium"
          :min="0"
          :max="100"
          label="请输入结束分数"
        ></el-input-number>
      </el-form-item>
      <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
        <div
          style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
        >奖品区域</div>
        <el-collapse accordion>
          <el-collapse-item v-for="(item, index) in form.gifts" :key="index">
            <span
              slot="title"
              style="font-size:15px;font-weight:600; margin:20px;"
            >奖品名称： {{item.name}}</span>
            <el-form-item label="奖品名称" required>
              <el-input v-model="item.name" placeholder="请输入奖品名称" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="数量" required>
              <el-input v-model="item.count" placeholder="请输入奖品数量" :clearable="true"></el-input>
            </el-form-item>
            <el-collapse accordion>
              <el-collapse-item>
                <span
                  style="font-size:14px;font-weight:600; margin:20px;padding-left:110px"
                  slot="title"
                >
                  奖品信息
                  <i class="header-icon el-icon-info" style="margin-left: 10px;"></i>
                </span>
                <el-form-item label="奖品Icon" required>
                  <uploadImg
                    v-model="item.icon"
                    :imgSize="1"
                    :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
                  ></uploadImg>
                </el-form-item>
                <el-form-item label="类型">
                  <prizeType
                    @skuType="skuTypes"
                    @getselect="getselects"
                    :prizeindex="index"
                    :type="item.type"
                    :prizeval="item.value"
                  ></prizeType>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
            <div style="display: flex;justify-content: center;margin-top: 14px;">
              <el-button
                type="danger"
                size="mini"
                @click="removeList(index)"
                v-if="index !== 0"
              >-删除奖品</el-button>
            </div>
          </el-collapse-item>
          <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
            <el-button type="primary" size="mini" @click="addList">+增加奖品</el-button>
          </div>
        </el-collapse>
      </div>
      <el-form-item label="活动规则类型" required>
        <el-radio-group v-model="form.ruleType" @change="selectRuleType">
          <el-radio :label="0">没有</el-radio>
          <el-radio :label="1">文字</el-radio>
          <el-radio :label="2">图片</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label required v-if="form.ruleType == 2">
        <uploadImg
          v-model="form.ruleDetail"
          :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label required v-if="form.ruleType == 1" prop="ruleDetail">
        <div class="ql-editor">
          <quill-editor
            ref="myQuillEditor"
            v-model="form.ruleDetail"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
        </div>
      </el-form-item>
    </el-form>
    <div class="footer" v-if="mapTrue">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">新 增</el-button>
    </div>
    <div class="footer" v-else>
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="success" @click="getModify('form')">编 辑</el-button>
    </div>
  </d2-container>
</template>
<script>
import uploadImg from '@/components/uploadImage/index.vue'
import prizeType from '@/components/prizeType/index.vue'
import {
  getFissionadd,
  getFissionupdate,
  getFissioninfo
} from '@/api/demo/fission/index'
import { getPosterList } from '@/api/demo/poster/index'
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
import { getToken } from '@/api/demo/classification/index'
Quill.register('modules/ImageExtend', ImageExtend)
// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  {
    Choice: '.ql-align .ql-picker-item[data-value="center"]',
    title: '居中对齐'
  },
  {
    Choice: '.ql-align .ql-picker-item[data-value="right"]',
    title: '居右对齐'
  },
  {
    Choice: '.ql-align .ql-picker-item[data-value="justify"]',
    title: '两端对齐'
  }
]
export default {
  name: 'editFission',
  components: {
    uploadImg,
    quillEditor,
    prizeType
  },
  data () {
    return {
      listQuery: {
        currentPage: 1,
        pageSize: 120,
        keyword: ''
      },
      mapTrue: true,
      list: [],
      fissionId: '', // id
      form: {
        title: '', // 活动标题
        name: '', // 活动名称
        bgImg: '', // 主页背景图片
        drawBgImg: '', // 抽奖动画
        openBgImg: '', // 开启页背景
        supBgImg: '', // 申请页背景
        posterId: '', // 邀请海报id
        supPosterId: '', // 支持海报id
        startTime: '', // startTime
        endTime: '', // 结束时间
        oldUserValType: 0, // 0 固定值 1 随机值
        oldUserVal: '', // 老用户支持分数范围开始值/固定值
        oldUserValEnd: '', // 老用户支持分数范围结束值
        newUserValType: 0, // 0 固定值 1 随机值
        newUserVal: '', // 新用户支持分数范围开始值/固定值
        newUserValEnd: '', // 新用户支持分数范围结束值
        ruleDetail: '', // 规则详情
        ruleType: 0, // 活动规则类型 0 没有 1 文字 2 图片
        gifts: [
          {
            count: 0, // 数量
            icon: '',
            name: '', // 奖品名称
            type: 0,
            value: ''
          }
        ]
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入活动标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入活动名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        bgImg: [
          {
            required: true,
            message: '请上传主页背景图片',
            trigger: 'change'
          }
        ],
        drawBgImg: [
          {
            required: true,
            message: '请上传抽奖动画',
            trigger: 'change'
          }
        ],
        openBgImg: [
          {
            required: true,
            message: '请上传开启页背景',
            trigger: 'change'
          }
        ],
        supBgImg: [
          {
            required: true,
            message: '请上传申请页背景',
            trigger: 'change'
          }
        ],
        posterId: [
          {
            required: true,
            message: '请选择邀请海报',
            trigger: 'change'
          }
        ],
        supPosterId: [
          {
            required: true,
            message: '请选择支持海报',
            trigger: 'change'
          }
        ],
        startTime: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        endTime: [{ required: true, message: '请选择日期', trigger: 'change' }]
        // oldUserVal: [
        //   {
        //     required: true,
        //     message: "请输入老用户支持分数",
        //     trigger: "blur"
        //   }
        // ]
      },
      // 富文本框参数设置
      editorOption: {
        modules: {
          ImageExtend: {
            loading: true,
            name: 'file',
            //   size: 2,
            action: 'https://up-z2.qiniup.com',
            response: res => {
              return this.https + '/' + res.key
            },
            change: (xhr, formData) => {
              formData.append('token', this.uploadData.token)
              formData.append('key', `upload_pic_${new Date().getTime()}`)
            }
          },
          toolbar: {
            container: container,
            handlers: {
              image: function (value) {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      uploadData: { key: '', token: '' }
    }
  },
  created () {
    let that = this
    that.getList()
    that.fissionId = that.$route.query.id
    if (that.fissionId != null) {
      that.getInfo(that.fissionId)
      that.mapTrue = false
    } else {
    }
  },
  methods: {
    getInfo (fissionId) {
      let that = this
      getFissioninfo(fissionId).then(res => {
        res.ruleType = Number(res.ruleType)
        that.form = res
      })
    },
    skuTypes (val1, val2) {
      let that = this
      for (let index = 0; index < that.form.gifts.length; index++) {
        if (index == val2) {
          that.form.gifts[index].type = val1
        }
      }
      // console.log("val", val1, val2);
    },
    getselects (val1, val2) {
      let that = this
      for (let index = 0; index < that.form.gifts.length; index++) {
        if (index == val2) {
          that.form.gifts[index].value = val1
        }
      }
      // console.log('that.form.gifts',that.form.gifts)
    },
    initTitle () {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    // 活动规则
    selectRuleType (e) {
      let that = this
      that.form.ruleType = e
      if (that.form.ruleType == 1) {
        that.initTitle()
      }
    },
    getList () {
      let that = this
      getPosterList(that.listQuery).then(res => {
        that.list = res.records
      })
    },
    // 开始时间
    getStartTime (e) {
      this.form.startTime = e
      // console.log("e", this.form.startTime);
    },
    // 结束时间
    getEndTime (e) {
      this.form.endTime = e
      // console.log("e", this.form.endTime);
    },
    onEditorBlur (quill) {
      // console.log("editor blur!", this.form.content, quill);
    },
    onEditorFocus (quill) {
      // console.log("editor focus!", this.form.content, quill);
    },
    onEditorReady (quill) {
      // console.log("editor ready!", quill);
    },
    addList () {
      let that = this
      that.form.gifts.push({
        count: 0, // 数量
        icon: '',
        name: '', // 奖品名称
        type: 0,
        value: ''
      })
    },
    // 删除奖品集合
    removeList (index) {
      this.form.gifts.splice(index, 1)
      this.form.gifts.forEach((item, index) => {
        item.index = index
      })
    },
    // 取消
    cancel () {
      let that = this
      that.$router.push('/demo/fission')
    },
    // 新增
    getCreate (forms) {
      let that = this
      if (that.form.ruleType == 1) {
        that.getreplace(that.form.ruleDetail)
      }
      that.$refs[forms].validate(valid => {
        getFissionadd(that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          that.$router.push({
            path: '/demo/fission'
          })
        })
      })
    },
    getreplace (ruleDetail) {
      let that = this
      // console.log("ruleDetail", ruleDetail);
      that.form.ruleDetail = ruleDetail.replace(
        /(\<img|\<p|\<blockquote|\undefined|\<br>|re |\<\/pre>|\<li|<a href|\><\/a>)/gi,
        function ($0, $1) {
          return {
            're ': '><pre ',
            '</pre>': '</pre>',
            '<p': '<p style="line-height:30px;"',
            // text-indent:1em;
            '<img':
              '<img style="max-width:100%;height:auto;margin:5px 0;display:flex;justify-content:center;text-align:center"',
            '<li': '<li style = "line-height:30px"',
            '<blockquote':
              '<blockquote style="border-left: 4px solid #ccc;margin-bottom: 5px;margin-top: 5px;padding-left: 16px;"',
            undefined: '',
            '<br>': '<br>',
            '<a href': `<a style="color:blue;cursor: pointer;" href`,
            '></a>': '/></a>'
          }[$1]
        }
      )
    },
    // 编辑
    getModify (forms) {
      let that = this
      if (that.form.ruleType == 1) {
        that.getreplace(that.form.ruleDetail)
      }
      that.$refs[forms].validate(valid => {
        getFissionupdate(that.fissionId, that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          that.$router.push({
            path: '/demo/fission'
          })
        })
      })
    }
  },
  mounted () {
    let that = this
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
  }
}
</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
</style>
